import React, { useState, useEffect, useRef } from 'react';
import style from './PreQuestion.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { styled } from '@mui/material/styles';
import LinearProgress, {linearProgressClasses,} from '@mui/material/LinearProgress';
import { useNavigate } from "react-router-dom";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const PreQuestion = () => {

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
        
            useEffect(() => {
                setOpen(false);
            }, []);
        
            function onDismiss() {
                setOpen(false);
            }
   
    return (
        <>
            <HeadSub title="혈액암 수술 내원 전 사전 질문지 어쩌고 저쩌고 길어짐 어쩌고 저쩌고 길어짐 길어짐 길어짐" />
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">

                    <div className={style["progress-box"]}>
                        <p className={style["progress-count"]}>
                            <span>1</span>/<span>10</span>
                        </p>

                        <BorderLinearProgress
                            variant="determinate"
                            value={10}
                            className={style['border-linear-progress']}
                        />
                    </div>


                    <strong className={style["text-title"]}>
                    %질문노출영역입니다.%
                    </strong>


                    {/* 감정 선택 :: S */}
                    <div className={style['select-list-box']}>
                        <ul>
                            <li>
                               <div className='radio-selectbox'>
                                    <input type="radio" id="emotion1" name='emotion-select'/>
                                    <label htmlFor="emotion1">
                                        <span>%선택값 1%</span>
                                    </label>
                                </div>  
                            </li>
                            <li>
                               <div className='radio-selectbox'>
                                    <input type="radio" id="emotion2" name='emotion-select'/>
                                    <label htmlFor="emotion2">
                                        <span>%선택값 2%</span>
                                    </label>
                                </div>  
                            </li>
                            <li>
                               <div className='radio-selectbox'>
                                    <input type="radio" id="emotion3" name='emotion-select'/>
                                    <label htmlFor="emotion3">
                                        <span>%선택값 3%</span>
                                    </label>
                                </div>  
                            </li>
                            <li>
                               <div className='radio-selectbox'>
                                    <input type="radio" id="emotion4" name='emotion-select'/>
                                    <label htmlFor="emotion4">
                                        <span>%선택값 4%</span>
                                    </label>
                                </div>  
                            </li>
                        </ul>
                    </div>
                    {/* 질문문 선택 :: E */}       




                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                            <div className="inner-box">
                                 <div className='btn-layout' data-btn-num="2"> 
                                    <button className="btn" data-btn-type="outline-main" data-btn-size="lg" onClick={() => navigate(-1)}>
                                        <span>이전</span>
                                    </button>
                                    <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                        <span>다음</span>
                                    </button>
                                </div>
 
                            </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 

                </div>
            </div>
        </>
    );
};

export default PreQuestion;
